const mixIsDynamic = {
  computed: {
    // 判断
    isDynamic: function() {
      for (let i = 0; i < this.widgetForm.column.length; i++) {
        let item = this.widgetForm.column[i]
        if (item.type === 'group') {
          let ret = this.setDynamicArray(item.children.column)
          if (ret) {
            return true
          }
        }
      }
      return this.setDynamicArray(this.widgetForm.column)
    }
  },
  mounted() {
    if (!this.isDynamic) {
      // 加载字典
      this.getResource()
      // 如果所选字段有值,常饿一次
      if (this.data.resourceId) {
        this.resourceIdChange(this.data.resourceId)
      }
    }
  },
  methods: {
    setDynamicArray(column) {
      let dynamicArray = column.filter(item => item.type === 'dynamic')
      if (dynamicArray.length === 0) {
        return false
      } else {
        for (let i = 0; i < dynamicArray.length; i++) {
          let itemArray = dynamicArray[i].children.column.filter(item => item === this.data)
          if (itemArray.length === 1) {
            if (dynamicArray[i].resourceId) {
              this.data.resourceId = dynamicArray[i].resourceId
              this.resourceIdChange(dynamicArray[i].resourceId)
            }
            return true
          }
        }
        return false
      }
    },
    /** 获得配置资源 */
    getResource() {
      this.$http.post('/data-collection-resourece/table-or-view-query', { entity: {}}, {
        params: {
          pageNum: 1,
          pageSize: 999
        }
      }).then(response => {
        this.resource = response.data.records.map(item => ({ tableComment: item.tableComment, resourceId: item.id }))
      }).catch(error => this.$message.error(error.msg || error.message))
    },
    // resourceId 改变加载可选字段
    resourceIdChange(resourceId) {
      if (resourceId) {
        this.$http.get('/data-collection-resourece/field-query', {
          params: {
            resourceId
          }
        }).then(response => {
          this.field = response.data
        }).catch(error => this.$message.error(error.msg || error.message))
      } else {
        this.data.fieldName = ''
        this.field = []
      }
    }
  }
}

export default mixIsDynamic
